import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DataListingProviderComponent } from 'src/app/shared/components/data-listing-provider/data-listing-provider.component';
import { AuthenticationGuard } from 'src/app/shared/guard/authentication-guard';
import { Entity } from 'src/app/shared/store/view/types';
import { HasUnsavedChangesGuard } from '../../../shared/guard/has-form-changed.guard';
import { ModuleId } from '../../../shared/store/navigation/types';
import { HeaderMenuType } from '../../../shared/store/view/types';
import { LostReasonCreateComponent } from './lost-reason-create/lost-reason-create.component';
import { LostReasonDetailsComponent } from './lost-reason-details/lost-reason-details.component';
import { LostReasonEditComponent } from './lost-reason-edit/lost-reason-edit.component';

const routes: Routes = [
  {
    path: 'Crm/LostReasons',
    data: {
      breadcrumb: { label: ' ', alias: 'list' },
    },
    children: [
      {
        path: '',
        redirectTo: 'List',
        pathMatch: 'full',
      },
      {
        path: 'List',
        component: DataListingProviderComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Sales,
          moduleId: ModuleId.crm,
          entity: Entity.LeadLostReason,
          breadcrumb: { skip: true },
        },
      },
      {
        path: 'Details/:id',
        component: LostReasonDetailsComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Sales,
          moduleId: ModuleId.crm,
          entity: Entity.LeadLostReason,
          breadcrumb: { label: ' ', alias: 'lostReasonDetails' },
        },
      },
      {
        path: 'Create',
        component: LostReasonCreateComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Sales,
          moduleId: ModuleId.crm,
          entity: Entity.LeadLostReason,
          breadcrumb: { label: ' ', alias: 'lostReasonCreate' },
        },
      },
      {
        path: 'Edit/:id',
        component: LostReasonEditComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Sales,
          moduleId: ModuleId.crm,
          entity: Entity.LeadLostReason,
          breadcrumb: { label: ' ', alias: 'lostReasonEdit' },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LostReasonRoutingModule {}
